if (!customElements.get('sunpura-meter-flow')) {
  customElements.define('sunpura-meter-flow', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.played === 'true' || this.dataset.motion !== 'true') return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.finish = () => {
        this.dataset.played = 'true';
        this.removeAttribute('data-pending');
        this.observer?.disconnect();
      };
      if (this.motion.matches || !('IntersectionObserver' in window)) {
        this.finish();
        return;
      }
      this.onMotion = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotion);
      this.setAttribute('data-pending', '');
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.finish();
      }, { threshold: 0.15 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.onMotion) this.motion?.removeEventListener('change', this.onMotion);
      this.removeAttribute('data-pending');
    }
  });
}

if (!customElements.get('sunpura-meter-partners')) {
  customElements.define('sunpura-meter-partners', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.list = this.querySelector('.sp-meter-partners__viewport');
      this.prev = this.querySelector('[data-partner-prev]');
      this.next = this.querySelector('[data-partner-next]');
      if (!this.list || !this.prev || !this.next) return;
      this.bound = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const maximum = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
          this.dataset.overflow = String(maximum > 2);
          this.prev.disabled = this.list.scrollLeft <= 2;
          this.next.disabled = this.list.scrollLeft >= maximum - 2;
        });
      };
      this.move = (direction, page = false) => {
        const first = this.list.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.list).columnGap || 0) : this.list.clientWidth;
        const amount = page ? Math.max(step, this.list.clientWidth - step / 2) : step;
        this.list.scrollBy({left: direction * amount, behavior: this.motion.matches ? 'instant' : 'smooth'});
      };
      this.onPrev = () => this.move(-1, true);
      this.onNext = () => this.move(1, true);
      this.onKey = event => {
        if (event.target !== this.list || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.list.scrollTo({left: event.key === 'Home' ? 0 : this.list.scrollWidth, behavior: this.motion.matches ? 'instant' : 'smooth'});
        }
      };
      this.onBlock = event => {
        if (!this.contains(event.target)) return;
        const tile = event.target.closest('[data-partner-device]');
        if (!tile) return;
        this.list.scrollTo({left: tile.getBoundingClientRect().left - this.list.getBoundingClientRect().left + this.list.scrollLeft, behavior: 'instant'});
      };
      this.list.addEventListener('scroll', this.update, {passive: true});
      this.list.addEventListener('keydown', this.onKey);
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      document.addEventListener('shopify:block:select', this.onBlock);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.list);
      this.mutations = new MutationObserver(this.update);
      this.mutations.observe(this.list, {childList: true});
      this.classList.add('is-ready');
      this.update();
    }
    disconnectedCallback() {
      if (!this.bound) return;
      cancelAnimationFrame(this.frame);
      this.resize?.disconnect();
      this.mutations?.disconnect();
      this.list.removeEventListener('scroll', this.update);
      this.list.removeEventListener('keydown', this.onKey);
      this.prev.removeEventListener('click', this.onPrev);
      this.next.removeEventListener('click', this.onNext);
      document.removeEventListener('shopify:block:select', this.onBlock);
      this.classList.remove('is-ready');
      this.bound = false;
    }
  });
}
